import { render, staticRenderFns } from "./StarterPackDrawerComm.vue?vue&type=template&id=0e50f482&scoped=true"
import script from "./StarterPackDrawerComm.vue?vue&type=script&lang=js"
export * from "./StarterPackDrawerComm.vue?vue&type=script&lang=js"
import style0 from "./StarterPackDrawerComm.vue?vue&type=style&index=0&id=0e50f482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50f482",
  null
  
)

export default component.exports